import { QueryBooleanSchema } from 'notable-common';
import { z } from 'zod';
import { Language } from '../demographics/language.js';
/** Route params for the patient app endpoints addressing a single previsit form set. */
export const PrevisitAppFormSetIdParamsSchema = z.object({ formSetId: z.uuid() }).strict();
/** Start accepts any non-empty id: it is the first call a link makes, before the id is trusted. */
export const PrevisitAppFormSetStartParamsSchema = z
    .object({ formSetId: z.string().min(1) })
    .strict();
export const PrevisitAppFormFieldParamsSchema = z
    .object({ formSetId: z.uuid(), formFieldId: z.uuid() })
    .strict();
/**
 * `v2` selects the multi-set response; `future` and `patientInfo` only widen what that response
 * carries, so the older single-set client can keep sending neither.
 */
export const PrevisitAppFormSetGetQuerySchema = z
    .object({
    authenticationCode: z.string().min(1),
    lang: z.enum(Language).optional(),
    v2: QueryBooleanSchema.default(false),
    future: QueryBooleanSchema.default(false),
    patientInfo: QueryBooleanSchema.default(false),
})
    .strict();
/** The session cookie already authorizes the patient here, so the code is accepted, not demanded. */
export const PrevisitAppFormSetStartQuerySchema = z
    .object({ authenticationCode: z.string().min(1).optional() })
    .strict();
export const PrevisitAppFormSetSubmitQuerySchema = z
    .object({ authenticationCode: z.string().min(1) })
    .strict();
/** Clearing a field is sending the empty string, so a value is required but may be blank. */
export const PrevisitAppFormFieldUpdateSchema = z.object({ value: z.string() });
export const PrevisitAppFormFieldBulkUpdateSchema = z
    .object({
    fields: z.array(z.object({ id: z.uuid(), value: z.string() })).min(1),
})
    .strict();
//# sourceMappingURL=patientApp.js.map